import * as Yup from 'yup'
import mime from 'mime'

Yup.addMethod(Yup.mixed, 'file', function (errorMessage = 'Is not file') {
  return this.test('file', errorMessage, function (value) {
    const { path, createError } = this

    if (!value) {
      return true
    }

    return value instanceof File || createError({ path, message: errorMessage })
  })
})

Yup.addMethod(Yup.mixed, 'fileExt', function (extension, errorMessage = 'Unsupported Format') {
  const extensions = extension.split(',')
  const mimes = extensions.map((ext) => mime.getType(ext))

  return this.test('fileExt', errorMessage, (value) => {
    if (!value) {
      return true
    }

    const fileExt = value.name.split('.').pop().toLowerCase()

    return mimes.includes(value.type) || extensions.includes(fileExt)
  })
})

Yup.addMethod(Yup.mixed, 'fileSize', function (size, errorMessage = 'File too large') {
  return this.test('fileSize', errorMessage, (value) => {
    if (!value) {
      return true
    }

    return value.size <= size * 1024
  })
})
